(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["afo-contact"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('afo-contact')) {
    class AfoContact extends HTMLElement {
      connectedCallback() {
        this.updateStatus();
        this.timer = setInterval(() => this.updateStatus(), 60000);

        /* Topic-aware message placeholder */
        this.message = this.querySelector('[data-afo-message]');
        this.defaultPlaceholder = this.message ? this.message.placeholder : '';
        this.onTopic = (e) => {
          if (!e.target.matches('.afo-contact__topic') || !this.message) return;
          this.message.placeholder = e.target.dataset.placeholder || this.defaultPlaceholder;
        };
        this.addEventListener('change', this.onTopic);
        const checked = this.querySelector('.afo-contact__topic:checked');
        if (checked && this.message) this.message.placeholder = checked.dataset.placeholder || this.defaultPlaceholder;

        /* Open the site's chat widget */
        this.querySelectorAll('[data-afo-open-chat]').forEach((btn) => {
          btn.addEventListener('click', () => this.openChat());
        });

        /* After a submit, bring the success or error message into view */
        const focusTarget = this.querySelector('[data-afo-focus]');
        if (focusTarget) {
          const form = this.querySelector('#afo-contact-form');
          if (form) form.scrollIntoView({ block: 'start' });
          focusTarget.focus({ preventScroll: true });
        }
      }

      disconnectedCallback() {
        clearInterval(this.timer);
        this.removeEventListener('change', this.onTopic);
      }

      openChat() {
        const custom = this.dataset.chatSelector;
        if (custom) {
          const el = document.querySelector(custom);
          if (el) {
            el.click();
            return;
          }
        }
        try {
          /* Shopify Inbox */
          const inbox = document.querySelector('inbox-online-store-chat');
          const inboxBtn = inbox && inbox.shadowRoot && inbox.shadowRoot.querySelector('button');
          if (inboxBtn) return inboxBtn.click();
          /* Common chat apps */
          if (window.tidioChatApi) return window.tidioChatApi.open();
          if (window.GorgiasChat && window.GorgiasChat.open) return window.GorgiasChat.open();
          if (window.$crisp) return window.$crisp.push(['do', 'chat:open']);
          if (window.Intercom) return window.Intercom('show');
          if (window.zE) return window.zE('messenger', 'open');
          if (window.LiveChatWidget) return window.LiveChatWidget.call('maximize');
          if (window.Reamaze && window.Reamaze.popup) return window.Reamaze.popup();
        } catch (e) {
          /* fall through to the form */
        }
        const form = this.querySelector('#afo-contact-form');
        if (form) form.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      updateStatus() {
        const status = this.querySelector('[data-afo-status]');
        const label = this.querySelector('[data-afo-status-text]');
        if (!status || !label) return;

        const tz = this.dataset.tz || 'America/New_York';
        let parts;
        try {
          parts = new Intl.DateTimeFormat('en-US', {
            timeZone: tz,
            weekday: 'short',
            hour: 'numeric',
            minute: 'numeric',
            hourCycle: 'h23',
          }).formatToParts(new Date());
        } catch (e) {
          return;
        }

        const get = (type) => (parts.find((p) => p.type === type) || {}).value;
        const day = get('weekday');
        const now = parseInt(get('hour'), 10) + parseInt(get('minute'), 10) / 60;
        const isWeekend = (d) => d === 'Sat' || d === 'Sun';
        const hoursFor = (d) =>
          isWeekend(d)
            ? [parseFloat(this.dataset.weekendOpen), parseFloat(this.dataset.weekendClose)]
            : [parseFloat(this.dataset.weekdayOpen), parseFloat(this.dataset.weekdayClose)];
        const fmt = (h) => {
          const hr = Math.floor(h);
          const min = Math.round((h - hr) * 60);
          const suffix = hr >= 12 ? 'pm' : 'am';
          const h12 = hr % 12 === 0 ? 12 : hr % 12;
          return min ? `${h12}:${String(min).padStart(2, '0')}${suffix}` : `${h12}${suffix}`;
        };

        /* Highlight today's row */
        this.querySelectorAll('[data-afo-days]').forEach((row) => {
          row.classList.toggle('is-today', row.dataset.afoDays === (isWeekend(day) ? 'weekend' : 'weekday'));
        });

        const [open, close] = hoursFor(day);
        if (isNaN(open) || isNaN(close)) return;

        if (now >= open && now < close) {
          status.classList.remove('is-closed');
          label.textContent = `Open now · until ${fmt(close)} ET`;
        } else if (now < open) {
          status.classList.add('is-closed');
          label.textContent = `Closed · opens at ${fmt(open)} ET`;
        } else {
          const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
          const tomorrow = days[(days.indexOf(day) + 1) % 7];
          status.classList.add('is-closed');
          label.textContent = `Closed · opens tomorrow at ${fmt(hoursFor(tomorrow)[0])} ET`;
        }
        status.hidden = false;
      }
    }
    customElements.define('afo-contact', AfoContact);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["afo-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('afo-footer')) {
    class AfoFooter extends HTMLElement {
      connectedCallback() {
        this.desktop = window.matchMedia('(min-width: 990px)');
        this.onBreakpoint = () => this.syncAccordions();
        this.desktop.addEventListener('change', this.onBreakpoint);
        this.syncAccordions();
        this.updateStatus();
        this.timer = setInterval(() => this.updateStatus(), 60000);
      }

      disconnectedCallback() {
        if (this.desktop) this.desktop.removeEventListener('change', this.onBreakpoint);
        clearInterval(this.timer);
      }

      /* Menus are always open on desktop, collapsed accordions on mobile */
      syncAccordions() {
        this.querySelectorAll('[data-afo-accordion]').forEach((el) => {
          el.open = this.desktop.matches;
        });
      }

      /* "Open now" indicator, computed in the store's time zone */
      updateStatus() {
        const status = this.querySelector('[data-afo-status]');
        const label = this.querySelector('[data-afo-status-text]');
        if (!status || !label) return;

        const tz = this.dataset.tz || 'America/New_York';
        let parts;
        try {
          parts = new Intl.DateTimeFormat('en-US', {
            timeZone: tz,
            weekday: 'short',
            hour: 'numeric',
            minute: 'numeric',
            hourCycle: 'h23',
          }).formatToParts(new Date());
        } catch (e) {
          return;
        }

        const get = (type) => (parts.find((p) => p.type === type) || {}).value;
        const day = get('weekday');
        const now = parseInt(get('hour'), 10) + parseInt(get('minute'), 10) / 60;
        const isWeekend = (d) => d === 'Sat' || d === 'Sun';
        const hoursFor = (d) =>
          isWeekend(d)
            ? [parseFloat(this.dataset.weekendOpen), parseFloat(this.dataset.weekendClose)]
            : [parseFloat(this.dataset.weekdayOpen), parseFloat(this.dataset.weekdayClose)];

        const fmt = (h) => {
          const hr = Math.floor(h);
          const min = Math.round((h - hr) * 60);
          const suffix = hr >= 12 ? 'pm' : 'am';
          const h12 = hr % 12 === 0 ? 12 : hr % 12;
          return min ? `${h12}:${String(min).padStart(2, '0')}${suffix}` : `${h12}${suffix}`;
        };

        const [open, close] = hoursFor(day);
        if (isNaN(open) || isNaN(close)) return;

        if (now >= open && now < close) {
          status.classList.remove('is-closed');
          label.textContent = `Open now · until ${fmt(close)}`;
        } else if (now < open) {
          status.classList.add('is-closed');
          label.textContent = `Closed · opens at ${fmt(open)}`;
        } else {
          const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
          const tomorrow = days[(days.indexOf(day) + 1) % 7];
          status.classList.add('is-closed');
          label.textContent = `Closed · opens tomorrow at ${fmt(hoursFor(tomorrow)[0])}`;
        }
        status.hidden = false;
      }
    }
    customElements.define('afo-footer', AfoFooter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
